import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/resources/copy.png'
import _imports_1 from '@/resources/share.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Share with XXXX", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "line-break" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "description" }, "Once they create an account and schedule their first meeting using the referral link you will receive the credit to your account.", -1 /* HOISTED */)
const _hoisted_4 = { class: "link-container" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "link-header" }, "Referral Link", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "shareText" }, "Copy Link", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "shareImage",
  src: _imports_0
}, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { class: "primary share" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "shareText" }, "Share"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "shareImage",
    src: _imports_1
  })
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "secondary-buttons" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "outline share" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "shareText" }, "Preview"),
    /*#__PURE__*/_createElementVNode("img", {
      class: "shareImage",
      src: _imports_1
    })
  ])
], -1 /* HOISTED */)
const _hoisted_12 = {
  key: 1,
  class: "referral-send loading"
}
const _hoisted_13 = {
  key: 0,
  class: "request-container body error"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("There was an error processing your request")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Opt Profile")
const _hoisted_16 = {
  key: 1,
  class: "request-container loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.instance !== null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["referral-send flex-center", {'no-scroll': $setup.noScroll}])
      }, [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("input", {
            class: "url",
            ref: "referralLink",
            readonly: "",
            value: $setup.referralURL
          }, null, 8 /* PROPS */, _hoisted_6),
          _createElementVNode("div", { class: "primary-buttons" }, [
            _createElementVNode("button", {
              class: "primary share",
              onClick: $setup.copyToClipboard
            }, _hoisted_9),
            _hoisted_10
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", { class: "btn-container bottom-referral" }, [
          _createElementVNode("button", {
            class: "primary return",
            onClick: $setup.progress
          }, "Return to Dashboard")
        ])
      ], 2 /* CLASS */))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        ($props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_router_link, {
                class: "borderless toHome",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "borderless startOver",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('restart')))
              }, "Restart")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode($setup["Loader"])
            ]))
      ]))
}